<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>外管工作台</Breadcrumb-item>
        <Breadcrumb-item>主管管理</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="rule-bar">
      <span class="rule-dot"></span>
      口径：始终统计全部在职外教，不受工作台外教运营筛选影响。可量化动作闭环率只看新外教回访与出勤跟进；试用期、合同只统计已逾期，临近项单独提示。
    </div>
    <Spin v-if="loading" fix></Spin>

    <div class="sum-grid">
      <div v-for="item in summaryCards" :key="item.key" class="sum-card">
        <div class="sum-label">{{ item.label }}</div>
        <div class="sum-value">{{ item.value }}</div>
        <div class="sum-foot">{{ item.foot }}</div>
      </div>
    </div>

    <div class="block">
      <div class="block-title">动作闭环检查</div>
      <div class="group-grid">
        <div v-for="g in groupCards" :key="g.key" class="group-card">
          <div class="group-head">
            <span class="group-label">{{ g.label }}</span>
            <span class="group-open" :class="{ 'is-danger': num(g.open) > 0 }">{{ num(g.open) }}<i>{{ g.unit || '项' }}</i></span>
          </div>
          <div class="group-rate" v-if="g.rate != null">闭环率 <b>{{ formatRate(g.rate) }}</b></div>
          <div class="group-meta" v-if="g.mode === 'rate'">应完成 {{ num(g.due) }} · 已完成 {{ num(g.done) }}</div>
          <div class="group-extra" v-if="g.extra">{{ g.extra }}</div>
          <div class="group-extra" v-if="num(g.soon) > 0">另 {{ num(g.soon) }} 项临近</div>
          <div class="group-extra" v-if="num(g.overdueMax) > 0">最长逾期 {{ num(g.overdueMax) }} 天</div>
        </div>
        <div v-if="!groupCards.length" class="group-empty">暂无动作数据</div>
      </div>
    </div>

    <div class="block">
      <div class="block-title">外管执行看板</div>
      <div class="block-note">按未闭环合计从多到少</div>
      <Table :columns="operatorColumns" :data="operatorRows" :loading="loading" stripe
             no-data-text="暂无外管数据"></Table>
    </div>

    <div class="block" ref="detailBlock">
      <div class="block-title">
        未闭环明细
        <span class="block-desc">共 {{ filteredItems.length }} 项</span>
      </div>
      <div class="filter-bar">
        <span class="toolbar-label">动作类型</span>
        <Select v-model="kindFilter" style="width: 160px;">
          <Option value="all">全部动作</Option>
          <Option v-for="item in kindOptions" :key="item.key" :value="item.key">{{ item.label }}</Option>
        </Select>
        <span class="toolbar-label">外管</span>
        <Select v-model="operatorFilter" style="width: 180px;" filterable>
          <Option value="all">全部外管</Option>
          <Option v-for="item in operatorOptions" :key="item.value" :value="item.value">{{ item.label }}</Option>
        </Select>
        <Button v-if="operatorFilter !== 'all' || kindFilter !== 'all'" @click="resetFilter">清除筛选</Button>
      </div>
      <Table :columns="itemColumns" :data="filteredItems" :loading="loading" stripe
             no-data-text="当前筛选下无未闭环事项"></Table>
    </div>

    <div class="block settings-block">
      <div class="block-title">规则与设置</div>
      <hr-workbench-settings embedded></hr-workbench-settings>
    </div>

    <review-save-modal :value="modal.review" :row="modalRow"
                       @on-close="modal.review = false" @on-success="load"></review-save-modal>
    <followup-handle-modal :value="modal.followup" :lessons="handleLessons"
                           @on-close="modal.followup = false" @on-success="load"></followup-handle-modal>
    <probation-decide-modal :value="modal.probation" :row="modalRow"
                            @on-close="modal.probation = false" @on-success="load"></probation-decide-modal>
    <contract-renew-modal :value="modal.contract" :row="modalRow"
                          @on-close="modal.contract = false" @on-success="load"></contract-renew-modal>
    <tch-info-modal :value="showTchInfoModal" :tchId="tchInfoId" @on-close="showTchInfoModal = false"></tch-info-modal>
  </div>
</template>
<script>
import HrWorkbenchSettings from './HrWorkbenchSettings.vue'
import ReviewSaveModal from './modal/ReviewSaveModal.vue'
import FollowupHandleModal from './modal/FollowupHandleModal.vue'
import ProbationDecideModal from './modal/ProbationDecideModal.vue'
import ContractRenewModal from './modal/ContractRenewModal.vue'
import TchInfoModal from '../teacher/modal/TchInfoModal.vue'
import { API_PREFIX, tchLabel } from './constants'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
const KIND_ORDER = ['REVIEW', 'FOLLOWUP', 'PROBATION', 'CONTRACT']
const KIND_META = {
  REVIEW: { text: '新外教回访', color: 'blue', action: '登记回访' },
  FOLLOWUP: { text: '出勤风险跟进', color: 'red', action: '登记跟进' },
  PROBATION: { text: '试用期结论', color: 'yellow', action: '试用期结论' },
  CONTRACT: { text: '合同续签', color: 'red', action: '登记续签' }
}
function num (v) {
  let n = Number(v)
  return isFinite(n) ? n : 0
}
function kindKey (kind) {
  return kind == null ? '' : String(kind).toUpperCase()
}
export default {
  name: 'HrWorkbenchSupervise',
  components: { HrWorkbenchSettings, ReviewSaveModal, FollowupHandleModal, ProbationDecideModal, ContractRenewModal, TchInfoModal },
  data () {
    return {
      loading: false,
      overallRate: null,
      totalDue: 0,
      totalDone: 0,
      totalOpen: 0,
      operatorOpenCount: 0,
      operatorCount: 0,
      maxOverdueDays: 0,
      groups: [],
      operators: [],
      items: [],
      kindFilter: 'all',
      operatorFilter: 'all',
      currentItem: null,
      handleLessons: [],
      showTchInfoModal: false,
      tchInfoId: null,
      rankScoreSeq: 0,
      modal: {
        review: false,
        followup: false,
        probation: false,
        contract: false
      },
      operatorColumns: [],
      itemColumns: []
    }
  },
  computed: {
    summaryCards () {
      let totalDue = num(this.totalDue)
      let totalDone = num(this.totalDone)
      return [
        {
          key: 'rate',
          label: '可量化动作闭环率',
          value: this.formatRate(this.overallRate),
          foot: '回访 + 出勤 ' + totalDone + ' / ' + totalDue
        },
        {
          key: 'open',
          label: '未闭环动作',
          value: num(this.totalOpen),
          foot: '四类未闭环合计'
        },
        {
          key: 'operator',
          label: '涉及外管',
          value: num(this.operatorOpenCount),
          foot: '未闭环明细涉及（含未分配）· 共 ' + num(this.operatorCount) + ' 位'
        },
        {
          key: 'overdue',
          label: '最长逾期',
          value: num(this.maxOverdueDays) + ' 天',
          foot: '明细最大逾期天数'
        }
      ]
    },
    groupCards () {
      let list = (this.groups || []).slice()
      list.sort(function (a, b) {
        let ia = KIND_ORDER.indexOf(kindKey(a.key))
        let ib = KIND_ORDER.indexOf(kindKey(b.key))
        if (ia < 0) {
          ia = KIND_ORDER.length
        }
        if (ib < 0) {
          ib = KIND_ORDER.length
        }
        return ia - ib
      })
      return list
    },
    operatorRows () {
      let list = (this.operators || []).slice()
      list.sort(function (a, b) {
        return num(b.openTasks) - num(a.openTasks)
      })
      return list
    },
    operatorOptions () {
      let options = (this.operators || []).map(function (op) {
        return {
          value: String(op.id),
          label: op.name || '未分配'
        }
      })
      let seen = {}
      options.forEach(function (op) {
        seen[op.value] = true
      })
      let extra = []
      let items = this.items || []
      items.forEach(function (item) {
        let value = String(item.operatorId)
        if (!seen[value]) {
          seen[value] = true
          extra.push({ value: value, label: item.operatorName || '未分配' })
        }
      })
      return options.concat(extra)
    },
    kindOptions () {
      return KIND_ORDER.map(function (key) {
        return { key: key, label: KIND_META[key].text }
      })
    },
    filteredItems () {
      let self = this
      return (this.items || []).filter(function (item) {
        if (self.kindFilter !== 'all' && kindKey(item.kind) !== self.kindFilter) {
          return false
        }
        if (self.operatorFilter !== 'all' && String(item.operatorId) !== self.operatorFilter) {
          return false
        }
        return true
      })
    },
    modalRow () {
      let item = this.currentItem
      if (!item) {
        return null
      }
      let kind = kindKey(item.kind)
      let overdue = num(item.overdueDays)
      return {
        tchId: item.tchId,
        tchName: item.tchName,
        country: item.country,
        reviewDue: kind === 'REVIEW' ? item.due : '',
        probationEnd: kind === 'PROBATION' ? item.due : '',
        crtEndDate: kind === 'CONTRACT' ? item.due : '',
        daysLeft: overdue > 0 ? -overdue : 0
      }
    }
  },
  created () {
    let self = this
    this.operatorColumns = [
      {
        title: '外管',
        key: 'name',
        width: 190,
        render: (h, params) => {
          let op = params.row
          return h('div', { class: 'op-cell' }, [
            h('span', { class: 'op-name' }, op.name || '未分配'),
            h('a', {
              class: 'op-link',
              attrs: { href: 'javascript:;' },
              on: { click: () => self.onlyOperator(op) }
            }, '只看 TA')
          ])
        }
      },
      {
        title: '在管老师',
        key: 'active',
        width: 95,
        align: 'center',
        render: (h, params) => h('span', num(params.row.active))
      },
      {
        title: '试用期中',
        key: 'onProbation',
        width: 95,
        align: 'center',
        render: (h, params) => h('span', num(params.row.onProbation))
      },
      {
        title: '回访逾期',
        key: 'reviewOpen',
        width: 95,
        align: 'center',
        render: (h, params) => self.renderCount(h, params.row.reviewOpen)
      },
      {
        title: '昨日跟进未登记',
        key: 'followupOpen',
        width: 125,
        align: 'center',
        render: (h, params) => self.renderCount(h, params.row.followupOpen)
      },
      {
        title: '试用期未结论',
        key: 'probationOpen',
        width: 110,
        align: 'center',
        render: (h, params) => self.renderCount(h, params.row.probationOpen)
      },
      {
        title: '合同超期',
        key: 'contractOpen',
        width: 95,
        align: 'center',
        render: (h, params) => self.renderCount(h, params.row.contractOpen)
      },
      {
        title: '风险（高危 / 监测人数）',
        key: 'risk',
        width: 170,
        align: 'center',
        render: (h, params) => h('span', num(params.row.riskHigh) + ' / ' + num(params.row.riskTotal))
      },
      {
        title: '未闭环合计',
        key: 'openTasks',
        width: 105,
        align: 'center',
        render: (h, params) => self.renderOpenTasks(h, params.row.openTasks)
      }
    ]
    this.itemColumns = [
      {
        title: '动作类型',
        key: 'kind',
        width: 130,
        render: (h, params) => self.renderKind(h, params.row.kind)
      },
      {
        title: '外管',
        key: 'operatorName',
        width: 130,
        render: (h, params) => h('span', params.row.operatorName || '未分配')
      },
      {
        title: '外教',
        key: 'tchName',
        width: 190,
        render: (h, params) => self.renderTch(h, params.row)
      },
      {
        title: '事项',
        key: 'title',
        minWidth: 260,
        render: (h, params) => self.renderTitle(h, params.row)
      },
      {
        title: '应完成日',
        key: 'due',
        width: 110,
        render: (h, params) => h('span', params.row.due || '—')
      },
      {
        title: '逾期天数',
        key: 'overdueDays',
        width: 100,
        align: 'center',
        render: (h, params) => self.renderOverdue(h, params.row.overdueDays)
      },
      {
        title: '操作',
        key: 'action',
        width: 200,
        align: 'center',
        render: (h, params) => self.renderAction(h, params.row)
      }
    ]
  },
  mounted () {
    this.load()
  },
  methods: {
    num (v) {
      return num(v)
    },
    formatRate (v) {
      if (v == null || v === '') {
        return '—'
      }
      let n = Number(v)
      if (!isFinite(n)) {
        return '—'
      }
      return (Math.round(n * 10) / 10) + '%'
    },
    kindText (kind) {
      let meta = KIND_META[kindKey(kind)]
      return meta ? meta.text : (kind || '—')
    },
    kindColor (kind) {
      let meta = KIND_META[kindKey(kind)]
      return meta ? meta.color : 'default'
    },
    kindAction (kind) {
      let meta = KIND_META[kindKey(kind)]
      return meta ? meta.action : ''
    },
    renderCount (h, value) {
      let n = num(value)
      return h('span', { class: n > 0 ? 'text-danger' : 'muted' }, n)
    },
    renderOpenTasks (h, value) {
      let n = num(value)
      return h('b', { class: n > 0 ? 'text-danger' : '' }, n)
    },
    renderKind (h, kind) {
      return h('Tag', { props: { color: this.kindColor(kind) } }, this.kindText(kind))
    },
    renderTch (h, row) {
      let self = this
      return h('div', { class: 'tch-cell' }, [
        renderTchNameWithScore(h, {
          text: tchLabel(row),
          score: row.monthRankScore,
          onClick: () => self.openTchInfo(row.tchId)
        }),
        h('div', { class: 'muted' }, 'ID ' + row.tchId)
      ])
    },
    renderTitle (h, row) {
      return h('div', { class: 'tch-cell' }, [
        h('div', row.title || '—'),
        row.detail ? h('div', { class: 'muted' }, row.detail) : null
      ])
    },
    renderOverdue (h, value) {
      let n = num(value)
      return h('b', { class: n > 0 ? 'text-danger' : '' }, n)
    },
    renderAction (h, row) {
      let self = this
      let nodes = [
        h('Button', {
          props: { size: 'small' },
          on: { click: () => self.openTchInfo(row.tchId) }
        }, '档案')
      ]
      let action = self.kindAction(row.kind)
      if (action) {
        nodes.push(h('Button', {
          props: { type: 'primary', size: 'small' },
          style: { marginLeft: '6px' },
          on: { click: () => self.openItem(row) }
        }, action))
      }
      return h('div', nodes)
    },
    load () {
      let self = this
      self.loading = true
      self.$http.post(API_PREFIX + '/supervise', {}).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          let d = res.data
          self.overallRate = d.overallRate
          self.totalDue = d.totalDue || 0
          self.totalDone = d.totalDone || 0
          self.totalOpen = d.totalOpen || 0
          self.operatorOpenCount = d.operatorOpenCount || 0
          self.operatorCount = d.operatorCount || 0
          self.maxOverdueDays = d.maxOverdueDays || 0
          self.groups = d.groups || []
          self.operators = d.operators || []
          self.items = d.items || []
          self.loadMonthRankScores()
        }
      }).finally(function () {
        self.loading = false
      })
    },
    loadMonthRankScores () {
      const rows = this.items || []
      if (!rows.length) {
        return
      }
      const ids = rows.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, rows, 'tchId', 'monthRankScore', map)
      })
    },
    resetFilter () {
      this.kindFilter = 'all'
      this.operatorFilter = 'all'
    },
    onlyOperator (op) {
      this.operatorFilter = String(op.id)
    },
    openItem (item) {
      let kind = kindKey(item.kind)
      this.currentItem = item
      if (kind === 'REVIEW') {
        this.modal.review = true
      } else if (kind === 'FOLLOWUP') {
        this.handleLessons = [this.toFollowupLesson(item)]
        this.modal.followup = true
      } else if (kind === 'PROBATION') {
        this.modal.probation = true
      } else if (kind === 'CONTRACT') {
        this.modal.contract = true
      }
    },
    toFollowupLesson (item) {
      return {
        lessonId: item.lessonId,
        manualId: item.manualId,
        manual: item.manualId != null,
        type: item.refType,
        tchId: item.tchId,
        tchName: item.tchName,
        lessonDate: item.lessonDate || item.due,
        reason: item.detail,
        handled: false
      }
    },
    openTchInfo (tchId) {
      if (!tchId) {
        return
      }
      this.tchInfoId = tchId
      this.showTchInfoModal = true
    }
  }
}
</script>
<style scoped lang="less">
.list {
  position: relative;
}
.rule-bar {
  margin: 8px 0 12px;
  padding: 8px 12px;
  background: #f8f8f9;
  border-radius: 4px;
  line-height: 22px;
  font-size: 12px;
  color: #495060;
}
.rule-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 4px;
  border-radius: 50%;
  background: #2d8cf0;
}
.sum-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}
.sum-card {
  padding: 14px 16px;
  border: 1px solid #e9eaec;
  border-radius: 4px;
  background: #fff;
}
.sum-label {
  font-size: 13px;
  color: #495060;
}
.sum-value {
  margin-top: 10px;
  font-size: 30px;
  font-weight: 600;
  line-height: 1.2;
  color: #1a1a1a;
}
.sum-foot {
  margin-top: 8px;
  font-size: 12px;
  color: #80848f;
}
.block {
  position: relative;
  margin-bottom: 16px;
  padding: 12px 16px;
  border: 1px solid #e9eaec;
  border-radius: 4px;
}
.block-title {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #495060;
}
.block-desc {
  margin-left: 8px;
  font-size: 12px;
  font-weight: normal;
  color: #80848f;
}
.block-note {
  margin: -4px 0 10px;
  font-size: 12px;
  color: #80848f;
}
.group-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}
.group-card {
  padding: 12px 14px;
  border: 1px solid #e9eaec;
  border-radius: 4px;
  background: #fafbfc;
}
.group-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.group-label {
  font-size: 13px;
  font-weight: 600;
  color: #495060;
}
.group-open {
  font-size: 24px;
  font-weight: 600;
  color: #495060;
  &.is-danger {
    color: #E6464E;
  }
  i {
    margin-left: 3px;
    font-size: 12px;
    font-style: normal;
    font-weight: normal;
    color: #80848f;
  }
}
.group-rate {
  margin-top: 6px;
  font-size: 12px;
  color: #495060;
  b {
    color: #0B9E8D;
  }
}
.group-meta {
  margin-top: 4px;
  font-size: 12px;
  color: #80848f;
}
.group-extra {
  margin-top: 4px;
  font-size: 12px;
  color: #80848f;
}
.group-empty {
  padding: 20px 0;
  font-size: 12px;
  color: #80848f;
}
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}
.toolbar-label {
  color: #495060;
}
.settings-block {
  padding-bottom: 4px;
}
.list /deep/ .muted {
  color: #80848f;
  font-size: 12px;
}
.list /deep/ .text-danger {
  color: #E6464E;
}
.list /deep/ .tch-cell {
  padding: 4px 0;
}
.list /deep/ .op-cell {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.list /deep/ .op-name {
  color: #495060;
}
.list /deep/ .op-link {
  font-size: 12px;
  white-space: nowrap;
}
@media (max-width: 1200px) {
  .sum-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .group-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 768px) {
  .sum-grid {
    grid-template-columns: 1fr;
  }
  .group-grid {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// HrWorkbenchSupervise.vue?056fbdf2